export const MIME_TYPES = Object.freeze({
  PNG: 'image/png',
  JPG: 'image/jpeg',
  PDF: 'application/pdf',
});
